import PurchaseView from "@/purchase/views/PurchaseView.vue";
import SupplierView from "@/purchase/views/SupplierView.vue";
import ArticleView from "@/purchase/views/ArticleView.vue";
import DisbursementView from "@/purchase/views/DisbursementView.vue";
import LogisticsView from "@/purchase/views/LogisticsView.vue";

export const purchaseRoutes = [
  {
    path: "/purchases",
    name: "Purchases",
    component: PurchaseView,
  },
  {
    path: "/purchase-suppliers",
    name: "PurchaseSuppliers",
    component: SupplierView,
  },
  {
    path: "/purchase-articles",
    name: "PurchaseArticles",
    component: ArticleView,
  },
  {
    path: "/purchase-logistics",
    name: "PurchaseLogistics",
    component: LogisticsView,
  },
  {
    path: "/purchase-disbursements",
    name: "PurchaseDisbursements",
    component: DisbursementView,
  },
];
